import { useQuery } from '@tanstack/react-query'
import { useLocale } from 'next-intl'
import { ApiResponseBody, userApiClient } from '@/setup/api'

export type IGetCitiesMapQueryData = ApiResponseBody<'get', '/web/cities/map'>['data']

export const getCitiesMapQueryOptions = (locale: string) =>
    userApiClient.queryOptions('get', '/web/cities/map', {
        headers: { 'accept-language': locale },
    })

export function useGetCitiesMapQuery() {
    const locale = useLocale()

    return useQuery(getCitiesMapQueryOptions(locale))
}
